const shortcutGroups = [
  {
    key: "general",
    label: "General",
    shortcuts: []
  },
  {
    key: "navigation",
    label: "Navigation",
    shortcuts: [
      {
        id: "go-home",
        binding: "Alt+1",
        keys: ["Alt", "1"],
        label: "Go to Home"
      },
      {
        id: "go-expenses",
        binding: "Alt+2",
        keys: ["Alt", "2"],
        label: "Go to Expenses"
      },
      {
        id: "go-analysis",
        binding: "Alt+3",
        keys: ["Alt", "3"],
        label: "Go to Analysis"
      },
      {
        id: "go-budget",
        binding: "Alt+4",
        keys: ["Alt", "4"],
        label: "Go to Budget"
      },
      {
        id: "go-settings",
        binding: "Alt+5",
        keys: ["Alt", "5"],
        label: "Go to Settings"
      },
      {
        id: "go-help",
        binding: "Alt+6",
        keys: ["Alt", "6"],
        label: "Go to Help"
      },
      {
        id: "next-year",
        binding: "Alt+Y",
        keys: ["Alt", "Y"],
        label: "Next year"
      },
      {
        id: "cycle-theme",
        binding: "Alt+P",
        keys: ["Alt", "P"],
        label: "Cycle theme"
      },
      {
        id: "focus-main-control",
        binding: "Alt+E",
        keys: ["Alt", "E"],
        label: "Focus main control"
      },
      {
        id: "open-dev",
        binding: "Alt+F12",
        keys: ["Alt", "F12"],
        label: "Open dev pages"
      }
    ]
  }
];

export const shortcutsById = new Map(
  shortcutGroups.flatMap((group) => group.shortcuts.map((shortcut) => [shortcut.id, shortcut]))
);
